module.exports = __webpack_public_path__ + "img/collect_pic_7.9adc0428.png";